import { useMemo } from 'react';
import { getParsedJwt, getTokens } from 'modules/oauth/tokenStore';

export const useLoginAccess = (): {
  hasAccess: boolean | undefined;
} => {
  const token = getTokens();

  const value = getParsedJwt(token?.accessToken);

  return useMemo(() => {
    const access = value?.scope
      ? value?.scope?.split(' ').some((s: string) => s === 'login')
      : undefined;
    return {
      hasAccess: access
    };
  }, [value]);
};
